import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t, getLocale } from './i18n';

// ============================================================
// Contorul de cost AI al unui client (etapa 7 a botului de comentarii, bucata 1 — 14 octombrie 2026).
//
// Hotararea Luminitei: vede DOAR ea (super admin) cat a cheltuit fiecare client pe AI de la
// inceputul lunii, in meniul din stanga, sub numele clientului; clientul primeste un raport lunar. Randurile vin din `cost_ai`,
// scrise de functii la fiecare cerere, cu tokenii raportati de Anthropic — deci cost real.
// Politica tabelului lasa doar super adminul sa citeasca; pentru ceilalti componenta nu apare.
// ============================================================

// Cursul cu care se arata leii. Acelasi ca in `inbox-ai` si `genereaza-texte` (USD_RON).
const USD_RON = 4.6;

// Ce a cerut fiecare rand, in cuvintele ecranului.
const FUNCTII = {
  'inbox-ai:triaj': 'costTriaj',
  'inbox-ai:raspunsuri': 'costCiorne',
  'genereaza-texte': 'costTexte',
  filtru: 'costFiltru',
};

const lei = (usd) => (usd * USD_RON).toLocaleString(getLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Raspunsul la „e super admin?" se cere o singura data pe sesiune, nu la fiecare client ales.
let eSuperAdminPromis = null;
function esteSuperAdmin() {
  if (!eSuperAdminPromis) eSuperAdminPromis = supabase.rpc('este_super_admin').then(r => !!r.data, () => false);
  return eSuperAdminPromis;
}

// Sub numele clientului, in meniul din stanga, in locul lui „0 de aprobat" (cerut de ea pe
// 14 octombrie seara: nu pe pagina de voce). Super adminul vede costul AI al lunii; ceilalti vad
// mai departe ce aveau (`altfel`). La trecerea mouse-ului apare impartirea pe feluri.
export function CostAILunaScurt({ clientId, altfel }) {
  const [eSuperAdmin, setESuperAdmin] = useState(false);
  const [randuri, setRanduri] = useState(null);

  useEffect(() => {
    let activ = true;
    setRanduri(null);
    (async () => {
      const sa = await esteSuperAdmin();
      if (!activ || !sa) return;
      setESuperAdmin(true);
      const acum = new Date();
      const inceputLuna = new Date(acum.getFullYear(), acum.getMonth(), 1).toISOString();
      const { data } = await supabase
        .from('cost_ai')
        .select('functie, usd, bucati, la, cheie')
        .eq('client_id', clientId)
        .gte('la', inceputLuna)
        .limit(20000);
      if (activ) setRanduri(data || []);
    })();
    return () => { activ = false; };
  }, [clientId]);

  if (!eSuperAdmin) return altfel;
  if (randuri === null) return '…';

  const total = randuri.reduce((s, r) => s + Number(r.usd || 0), 0);
  const peFunctie = {};
  randuri.forEach(r => {
    const k = FUNCTII[r.functie] ? r.functie : 'altele';
    peFunctie[k] = peFunctie[k] || { usd: 0, bucati: 0 };
    peFunctie[k].usd += Number(r.usd || 0);
    peFunctie[k].bucati += Number(r.bucati || 0);
  });
  const luna = new Date().toLocaleString(getLocale(), { month: 'long', timeZone: 'Europe/Bucharest' });
  const peCheiaLui = randuri.filter(r => r.cheie === 'client').reduce((s, r) => s + Number(r.usd || 0), 0);
  const detalii = Object.keys(peFunctie)
    .map(k => t('costAI', FUNCTII[k] || 'costAltele', { n: peFunctie[k].bucati }) + ': ' + lei(peFunctie[k].usd) + ' lei')
    .join('\n');

  return (
    <span title={(detalii || t('costAI', 'nimic')) + (peCheiaLui > 0 ? '\n' + t('costAI', 'peCheiaLui', { lei: lei(peCheiaLui) }) : '') + '\n\n' + t('costAI', 'nota', { curs: String(USD_RON).replace('.', ',') })}>
      {t('costAI', 'scurt', { luna, lei: lei(total) })}
    </span>
  );
}
